import { statusFilterToActive } from 'src/app/shared/utilities/status-filter';
import { UntypedFormControl } from '@angular/forms';
import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CompanyService } from '../services/company.service';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ICompany, IListByFilterEmpresas } from '../models/company.interface';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss']
})
export class CompaniesComponent implements OnInit, OnDestroy {
  ERoleAdminString = ERoleAdminString;
  private readonly destroy$ = new Subject<void>();
  ordenarControl = new UntypedFormControl(1);
  acaoInput = new UntypedFormControl();
  statusControl = new UntypedFormControl('all');
  companies: ICompany[] = [];
  dadosPaginacao = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  listOrder = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];
  constructor(
    private readonly companyService: CompanyService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.carregarEmpresas();
    this.ordenarControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((ordenacaoSelecionada: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = ordenacaoSelecionada;
      this.recarregarDoInicio();
    });

    this.statusControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.recarregarDoInicio();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  filtrarEmpresa(): void {
    this.recarregarDoInicio();
  }
  limparFiltros(): void {
    this.acaoInput.reset();
    this.statusControl.reset('all', { emitEvent: false });
    this.recarregarDoInicio();
  }
  carregarEmpresas(): void {
    const filtros = this.montarFiltros();

    this.companyService.listarTodasEmpresas(filtros).subscribe((resposta) => {
      this.companies = resposta.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(resposta.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = resposta.count!;
    });
  }

  /** Mudou um filtro, a ordenação ou o tamanho da página: a página atual pode não existir mais. */
  private recarregarDoInicio(): void {
    this.dadosPaginacao.paginaSelecionada = 0;
    this.carregarEmpresas();
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;
    this.carregarEmpresas();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.recarregarDoInicio();
  }

  public downloadExcel(): void {
    this.companyService.exportarExcelEmpresas(this.montarFiltros());
  }

  /** Mesmos filtros na listagem e no Excel, para o arquivo trazer o que está na tela. */
  private montarFiltros(): IListByFilterEmpresas {
    const filtros: IListByFilterEmpresas = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina),
      includeInactive: true
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    } else if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (this.acaoInput.value) {
      filtros.searchText = String(this.acaoInput.value);
    }

    // Empresa é a única listagem do company-api que esconde inativas quando `active` vem vazio,
    // por isso "Todos" precisa de includeInactive.
    const active = statusFilterToActive(this.statusControl.value);
    if (active !== undefined) {
      filtros.active = active;
      filtros.includeInactive = undefined;
    }

    return filtros;
  }
}
